export function scriptInsert(src, async = false) {
    var js;
    var tjs = document.getElementsByTagName('script')[0];
    js = document.createElement('script');
    js.src = src; js.type = 'text/javascript'; js.async = async;
    tjs.parentNode.insertBefore(js, tjs);
}